import { useContext, useMemo, useState } from "react"
import { AreaContext } from "../context/AreaContext"
import { Box,Table, TableRow, TableCell, Tooltip, IconButton, TableBody, Link, BottomNavigation, BottomNavigationAction } from "@mui/material";
import { formatBytes } from "../utils/ByteConverter";
import { HelpOutlineRounded, LibraryBooks } from "@mui/icons-material";

export const TotalStorageAllocation = () =>{

    const{area} = useContext(AreaContext);

    const [linkVal] = useState('');

    const handleChange = (event, newValue) => {
      window.open(newValue, '_blank').focus();
    };

    const renderStorage = () => {
        return(
        <Box sx={{ border: "2px solid black", borderRadius: 1, marginTop: "20px", marginBottom: "20px"}}>
            <Table>
              <TableBody>
                                <TableRow>
                    <TableCell align="center" sx={{width: "50%"}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mx: "auto", justifyContent: "center", width: "fit-content" }}>
                              Maximum Storage Allocation
                              <Tooltip 
                              title="The basline storage (10 GB per License) plus a summation of 10 TB Storage Packs purchased for your area"
                              placement="right"
                              arrow>
                                  <IconButton
                                    size="small"
                                    sx={{
                                      ml: 0.75,
                                      p: 0.25,
                                      color: "black",
                                      "& svg": { fontSize: "1rem" }
                                    }}
                                  >
                                  <HelpOutlineRounded />
                                </IconButton>
                              </Tooltip>
                            </Box>
                    </TableCell>
                    <TableCell align="center">{formatBytes(area.storageAllocation)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <BottomNavigation
              value={linkVal}
              onChange={handleChange}
              showLabels={true}>
              <BottomNavigationAction
                sx={{color: "#A60F2D" }} 
                label="WSU Usage Dashboard"
                value="https://wsuaacprodoac-wsucloud.analytics.ocp.oraclecloud.com/ui/dv/ui?pageid=visualAnalyzer&reportmode=full&reportpath=%2F%40Catalog%2Fshared%2FWSU%20O365%20Data%20Consumption%2FMicrosoft%20365%20Storage%20Consumption"
                icon={<LibraryBooks />}
              />
            </BottomNavigation>
        </Box>
        )
    }


    return renderStorage();


}